import { setURL } from '@/api/apiUtil'

export default {
  // 根據社區編號取得公設列表
  getPublicFacilityByCommunityId: {
    url: (communityId) =>
      setURL('/publicFacility/community/:communityId', { communityId }),
    method: 'get'
  },
  // 取得公設詳細資訊
  getPublicFacilityById: {
    url: (publicFacilityId) =>
      setURL('/publicFacility/:publicFacilityId', { publicFacilityId }),
    method: 'get'
  },
  // 新增公設
  postPublicFacility: {
    url: setURL('/publicFacility'),
    method: 'post'
  },
  // 編輯/更新公設資訊
  putPublicFacility: {
    url: (publicFacilityId) =>
      setURL('/publicFacility/:publicFacilityId', { publicFacilityId }),
    method: 'put'
  },
  // 刪除公設資訊
  deletePublicFacility: {
    url: (publicFacilityId) =>
      setURL('/publicFacility/:publicFacilityId', { publicFacilityId }),
    method: 'delete'
  },
  // 發佈公設資訊
  publishPublicFacility: {
    url: (publicFacilityId) =>
      setURL('/publicFacility/:publicFacilityId/publish', { publicFacilityId }),
    method: 'put'
  },
  // 取消發佈公設資訊
  cancelPublishPublicFacility: {
    url: (publicFacilityId) =>
      setURL('/publicFacility/:publicFacilityId/cancelPublish', {publicFacilityId}),
    method: 'put'
  }
}
